let lastId = 0;

export default function getUniqueId(prefix = 'id') {
  lastId += 1;
  return `${prefix}${lastId}`;
}
